module.exports = __webpack_public_path__ + "img/mega.cdb5ae7b.svg";